/** Theme app embed block handles of the app's theme app extension */
export const CART_APP_EMBED_BLOCK_HANDLE = 'pickup-app-embed-block';
export const SMART_DELIVERY_PAGE_APP_EMBED_BLOCK_HANDLE = 'pickupbird-smart-delivery-page-embed-block';

/** Opens the theme editor's App embeds with the given embed block ready to switch on (the cart one by default) */
export const goToThemesEditor = (blockHandle: string = CART_APP_EMBED_BLOCK_HANDLE) => {
    open(
        `shopify://admin/themes/current/editor?context=apps&template=index&activateAppId=${
            import.meta.env.VITE_APP_CLIENT_ID
        }/${blockHandle}`,
        '_blank'
    );
};
